import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource} from "kea-resource";

const controller = rpcController("GuiasEnviadasRecibidas");

/**Resource del reporte de estadísticas de clientes*/
export const RepGuiasEnviadasRecibidas = cacheResource({
    Generar: async (
        parametros: models.ParamsGuiasEnviadasRecibidas): Promise<string> =>
        await controller("GenerarReporteGuiasEnviadasRecibidas", {}, parametros)
}, {
    }, {
})


// WEBPACK FOOTER //
// ./app/resources/items/guiasenviadasrecibidas.tsx